import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_PATH}`;

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const dashboardAPI = {
    getDashboardSummary: async (params = {}) => {
        try {
            const response = await apiClient.get('golddashboard/summary', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching dashboard summary:', error);
            throw error;
        }
    },

    getMonthlyTrends: async (months = 12) => {
        try {
            const response = await apiClient.get('golddashboard/monthly-trends', { 
                params: { months } 
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching monthly trends:', error);
            throw error;
        }
    },

    getRecentTransactions: async (count = 10) => {
        try {
            const response = await apiClient.get('golddashboard/recent-transactions', { 
                params: { count } 
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching recent transactions:', error);
            throw error;
        }
    },

    getLoanPerformance: async () => {
        try {
            const response = await apiClient.get('golddashboard/loan-performance');
            return response.data;
        } catch (error) {
            console.error('Error fetching loan performance:', error);
            throw error;
        }
    },

    getGoldAssets: async () => {
        try {
            const response = await apiClient.get('golddashboard/gold-assets');
            return response.data;
        } catch (error) {
            console.error('Error fetching gold assets:', error);
            throw error;
        }
    },

    getStatusDistribution: async () => {
        try {
            const response = await apiClient.get('golddashboard/status-distribution');
            return response.data;
        } catch (error) {
            console.error('Error fetching status distribution:', error);
            throw error;
        }
    }
};
